export const YOUTUBE_CHANNEL = 'https://www.youtube.com/@goldenraja-s5k1s';

export function ytEmbedUrl(url) {
  if (!url) return null;
  const m =
    url.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/) ||
    url.match(/[?&]v=([A-Za-z0-9_-]{6,})/) ||
    url.match(/youtube\.com\/(?:live|embed|shorts)\/([A-Za-z0-9_-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0` : null;
}
